import { useRef } from 'react';

import { isEqual } from 'lodash';
/**
 * Memoizes the given value by using the provided equality check function.
 * Unlike the React.useMemo hook, this one allows for deep equality check for memoization.
 * Also, unlike its React counterpart, it can be used as a semantic guarantee (https://reactjs.org/docs/hooks-reference.html)
 *
 * @param value The value to be memoized.
 * @param equalityCheckFn The function that returns whether the two values are equal in terms of the memoization condition.
 * @returns The memoized value.
 */
export function useCustomMemo<T>(value: T, equalityCheckFn: (val1: T, val2: T) => boolean = isEqual): T {
  const valueRef = useRef<T>(value);

  if (!equalityCheckFn(value, valueRef.current)) {
    valueRef.current = value;
  }

  return valueRef.current;
}
